const Plugins = function (scribe) {
  const context = {}; //attach all plugin methods to this object. it is used to call plugins by reflection without using eval.

  context.unloadEventTracker = (...args) => {
    let eventName = "uploadEvent";
    let facets = args[0];
    window.addEventListener("beforeunload", () => {
      scribe.sendEvent(eventName, facets, true);
      scribe.flushData();
    });
  };

  const usePlugin = (command) => {
    [_, pluginName, ...pluginArguments] = command;
    context[pluginName](pluginArguments);
  };

  return Object.freeze({
    usePlugin,
  });
};

export { Plugins };
